import { DateTime } from "luxon";
import { useTranslation } from "react-i18next";
import { HiOutlineShare } from "react-icons/hi";

import { /*SvButton,*/ SvText } from "@/components";
/*import { SvCandidateBlock } from "@/components/SvCandidateBlock/SvCandidateBlock.tsx";
import { SvDialogBasic } from "@/components/SvDialog/SvDialogBasic.tsx";*/
import { SvDialogCustom } from "@/components/SvDialog/SvDialogCustom.tsx";
import { SvDialogShare } from "@/components/SvDialogShare/SvDialogShare.tsx";
import { SvIconButton } from "@/components/SvIconButton/SvIconButton.tsx";
import { SvVoteChart } from "@/components/SvVoteChart/SvVoteChart.tsx";
/*import { useRidingCandidatesQuery } from "@/data/queries/RidingQueries.ts";*/
import { RidingDataType } from "@/domain/models.tsx";

type SvRidingProjectionsProps = {
  ridingData: RidingDataType;
};

export const SvRidingProjections = ({
  ridingData,
}: SvRidingProjectionsProps) => {
  const { t, /*i18n*/ } = useTranslation();

  /*const { data: candidatesData } = useRidingCandidatesQuery(
    ridingData?.ridingNumber,
  );*/

  return (
    <div
      id="riding-projections-container"
      className="border-ind-grey-50 @container w-full max-w-5xl rounded-lg border bg-white p-6">
      <div className="mb-4 flex flex-row justify-between">
        <div className="flex flex-col gap-2">
          <SvText
            variant="title"
            i18nKey="projections.current_projection"
            className="text-left text-sm font-semibold @lg:text-lg">
            <span className="text-primary text-base @max-md:block @lg:text-lg">
              {ridingData.ridingName}
            </span>
          </SvText>
          <div className="flex flex-row flex-wrap gap-x-2 @lg:gap-x-4">
            <SvText
              i18nKey="projections.moe"
              variant="inline"
              className="text-sm font-bold">
              : <span className="font-normal">+/- {ridingData.moe}%</span>
            </SvText>
            <SvText
              i18nKey="projections.confidence"
              variant="inline"
              className="text-sm font-bold">
              : <span className="font-normal">{ridingData.confidence}%</span>
            </SvText>
            <SvText
              i18nKey="projections.updated"
              variant="inline"
              className="text-sm font-bold">
              :{" "}
              <span className="font-normal">
                {ridingData.date.toLocaleString(DateTime.DATE_MED)}
              </span>
            </SvText>
          </div>
          <div className="bg-ind-grey-50 self-start rounded-full px-4 py-1 text-xs font-medium">
            {ridingData.status.party &&
              t(ridingData.status.party.shortNameKey) + " "}
            {t(ridingData.status.statusKey)}
          </div>
        </div>
        <div className="flex h-max flex-row gap-2">
          <SvDialogCustom
            titleKey="share.title"
            className="max-w-md"
            descriptionKey="share.body"
            trigger={
              <SvIconButton
                className="image-ignore h-10 w-10 cursor-pointer"
                icon={<HiOutlineShare />}
              />
            }>
            <SvDialogShare
              riding={ridingData.ridingName}
              date={ridingData.date}
            />
          </SvDialogCustom>
        </div>
      </div>

      <div className="flex flex-col items-center justify-center gap-8 @min-[720px]:flex-row">
        {/*<div className="flex w-full flex-row flex-wrap items-center justify-center gap-2 @max-[720px]:order-2 @min-[720px]:w-56 @min-[720px]:flex-col">
          {ridingData.currentParty && (
            <SvCandidateBlock
              type="incumbent"
              party={ridingData.currentParty}
            />
          )}
          {ridingData.trendingParty && (
            <SvCandidateBlock
              type="trending"
              party={ridingData.trendingParty}
            />
          )}
          {ridingData.voteForParty && (
            <SvCandidateBlock
              type="vote_for"
              party={ridingData.voteForParty}
              className="sm:w-full sm:max-w-[448px]"
            />
          )}
          <SvDialogBasic
            trigger={
              <SvButton
                variant="outline"
                color="primary"
                i18nKey="projections.view_candidates"
                className="w-full"
              />
            }
            title={
              <SvText
                i18nKey="projections.candidate_list_title"
                i18nValues={{ riding: ridingData.ridingName }}
              />
            }>
            <ul className="list-inside list-disc">
              {candidatesData
                ?.filter(party => Boolean(party.candidate))
                .map(party => (
                  <li key={party.id} className="mb-2">
                    <strong>{t(party.fullNameKey)}:</strong> {party.candidate}
                  </li>
                ))}
            </ul>
            <SvText
              i18nKey="projections.candidates_disclaimer"
              i18nValues={{
                link: `https://www.elections.ca/Scripts/vis/candidates?L=${i18n.language.startsWith("fr") ? "f" : "e"}&ED=${ridingData.ridingNumber}&EV=62`,
              }}
              className="text-ind-grey-500 mt-4"
            />
          </SvDialogBasic>
        </div>*/}
        <div className="grow @max-[720px]:order-1 @max-[720px]:w-full">
          <SvVoteChart
            type={ridingData.isSplit ? "split" : "grey"}
            className="my-auto"
            data={ridingData.projection}
          />
        </div>
      </div>
    </div>
  );
};
